/**
 * SCO-33 — attribution shown wherever adventure requirement text appears (catalog,
 * meeting planning, advancement). Wording covers the dataset's CC BY-NC-SA 4.0 licence
 * and the separate © Scouting America carve-out on requirement text.
 */
export function Attribution({ textRights }: { textRights?: string | null }) {
  return (
    <p className="muted small attribution">
      Adventure data from{' '}
      <a href="https://github.com/sethmay/open-scout-api" target="_blank" rel="noreferrer">
        open-scout-api
      </a>{' '}
      (created by sethmay), licensed CC BY-NC-SA 4.0.{' '}
      {textRights ?? 'Requirement text © Scouting America, reproduced with attribution for non-commercial Scouting use.'}
    </p>
  );
}
